import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { memo } from 'react';
import classnames from 'classnames';
import SelectIcon from 'Shared/assets/icons/select.svg';
import styles from './DatasetItem.css';
const DatasetItem = ({ name, description, versionId, onChange: handleChange, onHover, isSelected = false, }) => {
    const handleHover = (event) => {
        event.stopPropagation();
        onHover(description);
    };
    const containerClassName = classnames(styles.container, {
        [styles.selected]: isSelected,
    });
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    return (_jsxs("li", Object.assign({ className: containerClassName, onMouseEnter: handleHover, onClick: () => handleChange(versionId), "data-testid": "DatasetControl.datasetversion", "aria-label": name }, { children: [_jsx("span", Object.assign({ className: styles.title }, { children: name }), void 0), isSelected && _jsx(SelectIcon, { className: styles.icon }, void 0)] }), void 0));
};
export default memo(DatasetItem);
